// Amateur Topic 3 — Market Structure. Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Market Structure',
  summary: 'Read the stairs of the chart: highs, lows, breaks and changes.',
  subtopics: [
    { title: 'What It Is', scene: 'mktWhat', cards: [
      { icon: '🪜', title: 'Stairs on the chart', body: 'Price never moves in a straight line. It goes up, rests, goes up again — like stairs.' },
      { icon: '🔺', title: 'Swing highs and lows', body: 'Each top is a swing high. Each dip is a swing low.' },
      { icon: '🧭', title: 'It shows the trend', body: 'How the highs and lows line up tells you if the trend is up, down or sideways.' },
      { icon: '🔭', title: 'Start big', body: 'Check structure on H4 or D1 first, then zoom in.' },
    ] },
    { title: 'HH & HL (and LH & LL)', scene: 'msHH', cards: [
      { icon: '⬆️', title: 'Higher High (HH)', body: 'A new top that is higher than the last top.' },
      { icon: '↗️', title: 'Higher Low (HL)', body: 'A new dip that stays above the last dip. HH + HL = uptrend.' },
      { icon: '⬇️', title: 'Lower High (LH)', body: 'A new top that is lower than the last top.' },
      { icon: '↘️', title: 'Lower Low (LL)', body: 'A new dip below the last dip. LH + LL = downtrend.' },
    ] },
    { title: 'Break of Structure (BOS)', scene: 'msBos', cards: [
      { icon: '💥', title: 'What BOS means', body: 'Price breaks the last high (in an uptrend) or the last low (in a downtrend).' },
      { icon: '➡️', title: 'Same direction', body: 'BOS goes WITH the trend. It says: the trend continues.' },
      { icon: '🕯️', title: 'Body close', body: 'Count it only when a candle BODY closes past the level, not just a wick.' },
      { icon: '🟡', title: 'Gold example', body: 'Last HH at 2,420. A candle closes at 2,428. That is a bullish BOS.' },
    ] },
    { title: 'Change of Character (CHoCH)', scene: 'msChoch', cards: [
      { icon: '⚠️', title: 'The first break against the trend', body: 'In an uptrend, CHoCH is when price closes below the last higher low.' },
      { icon: '🔄', title: 'A sign of change', body: 'It warns that the trend may be turning. It is often the first clue.' },
      { icon: '⏳', title: 'Not a promise', body: 'After a CHoCH, wait for lower highs to confirm the new downtrend.' },
      { icon: '🟡', title: 'Gold example', body: 'Last HL at 2,400. Gold makes a lower high, then closes at 2,392. That is a bearish CHoCH.' },
    ] },
  ],
};
